import { UserCorePortable } from "@3gaam/api/types/consultancy";
import { create } from "zustand";
import { immer as immerMiddleware } from "zustand/middleware/immer";

interface State {
  currentUser: UserCorePortable | undefined;
  updateCurrentUser: (currentUser: UserCorePortable | undefined | null) => void;
}

export const useCurrentUser = create<State>()(
  immerMiddleware((set, get) => ({
    currentUser: undefined,
    updateCurrentUser: (currentUser) => {
      set((state) => {
        state.currentUser = currentUser || undefined;
      });
    },
  })),
);
